import { Image } from "expo-image";
import React from "react";
import { Pressable, View } from "react-native";

import { Text } from "./ui/BrandText";
import { ImageViewerModal } from "./ImageViewerModal";
import { border, surface, text as uiText } from "../theme/tokens";

export function PostMediaGallery({ imageUrls, topSpacing = 10 }: { imageUrls: string[]; topSpacing?: number }) {
  const [viewerIndex, setViewerIndex] = React.useState<number | null>(null);
  const [failed, setFailed] = React.useState<Set<number>>(() => new Set());
  const visible = imageUrls.slice(0, 6);
  const imageKey = visible.join("\n");

  React.useEffect(() => {
    setFailed(new Set());
  }, [imageKey]);

  if (!visible.length) return null;

  return (
    <>
      <View style={{ marginTop: topSpacing, flexDirection: "row", flexWrap: "wrap", gap: 6, width: "100%", overflow: "hidden" }}>
        {visible.map((imageUrl, index) => {
          const firstOfThree = visible.length === 3 && index === 0;
          const fullWidth = visible.length === 1 || firstOfThree;
          const label = `Image ${index + 1} sur ${visible.length} de la publication`;
          return (
            <Pressable
              key={`${imageUrl}_${index}`}
              onPress={() => setViewerIndex(index)}
              accessibilityRole="button"
              accessibilityLabel={`Ouvrir ${label.toLowerCase()}`}
              style={{
                flexBasis: fullWidth ? "100%" : "48.5%",
                flexGrow: fullWidth ? 0 : 1,
                minWidth: 0,
                aspectRatio: fullWidth ? 16 / 9 : 1,
                maxHeight: fullWidth ? 420 : 300,
                borderRadius: 14,
                overflow: "hidden",
                borderWidth: 1,
                borderColor: border.subtle,
                backgroundColor: surface.primary,
              }}
            >
              {failed.has(index) ? (
                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", padding: 12 }}>
                  <Text style={{ color: uiText.muted, textAlign: "center" }}>Image indisponible</Text>
                </View>
              ) : (
                <Image
                  source={{ uri: imageUrl }}
                  cachePolicy="disk"
                  contentFit="cover"
                  transition={150}
                  accessibilityLabel={label}
                  onError={() => setFailed((current) => new Set(current).add(index))}
                  style={{ width: "100%", height: "100%", backgroundColor: surface.primary }}
                />
              )}
            </Pressable>
          );
        })}
      </View>
      <ImageViewerModal
        visible={viewerIndex !== null}
        imageUrls={visible}
        initialIndex={viewerIndex ?? 0}
        onClose={() => setViewerIndex(null)}
      />
    </>
  );
}
